import {Validators} from '@angular/forms';

import {ClientStatusesEnum, IndividualFilterModel, IndividualReportModel} from '@spa/api';

import {ComponentTypesEnum, UnspecifiedKeysEnum} from '../../app/shared/enums';
import {FilterControlInterface} from '../../app/shared/interfaces';
import {ReportTableData, ReportTableConfigInterface, ReportTableColumn} from '../../app/shared/components';
import {AutocompleteControl, BaseControl, Helper, SelectControl} from '../../app/shared/classes';

import {EnrollTypesEnum} from '../../app/entries/panel/enums';

import {EnrollDateSelector} from './panel-leads.descriptor';
export const PanelVerificationsStorageId = 'PanelVerificationsComponent';

export const PanelVerificationsFilterControls = (): FilterControlInterface[] => {
    return [
        {
            name: EnrollDateSelector,
            placeholder: 'Enroll date',
            controls: [
                new BaseControl({
                    name: IndividualFilterModel.getEnrollDateFromSelector(),
                    value: null,
                    placeholder: 'Enroll date from',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 1
                }),
                new BaseControl({
                    name: IndividualFilterModel.getEnrollDateToSelector(),
                    value: null,
                    placeholder: 'Enroll date to',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 2
                }),
            ],
            sortIndex: 1,
        }, {
            name: IndividualFilterModel.getStatusesSelector(),
            placeholder: 'Status',
            controls: [
                new SelectControl({
                    name: IndividualFilterModel.getStatusesSelector(),
                    value: ClientStatusesEnum.All,
                    placeholder: 'Status',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: []
                })
            ],
            sortIndex: 2
        },
        {
            name: IndividualFilterModel.getEnrollTypeSelector(),
            placeholder: 'Client Type',
            controls: [
                new SelectControl({
                    name: IndividualFilterModel.getEnrollTypeSelector(),
                    value: EnrollTypesEnum.All,
                    placeholder: 'Client Type',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper().getEnrollTypeName(EnrollTypesEnum.All),
                            value: EnrollTypesEnum.All
                        },
                        {
                            label: Helper.textsHelper().getEnrollTypeName(EnrollTypesEnum.Individual),
                            value: EnrollTypesEnum.Individual
                        },
                        {
                            label: Helper.textsHelper().getEnrollTypeName(EnrollTypesEnum.Corporate),
                            value: EnrollTypesEnum.Corporate
                        },
                    ]
                })
            ],
            sortIndex: 3
        },
        {
            name: IndividualFilterModel.getNameSelector(),
            placeholder: 'Name',
            controls: [
                new BaseControl({
                    name: IndividualFilterModel.getNameSelector(),
                    value: null,
                    placeholder: 'Name',
                    validators: [Validators.minLength(3)],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 4
        }, {
            name: IndividualFilterModel.getEmailSelector(),
            placeholder: 'Email',
            controls: [
                new BaseControl({
                    name: IndividualFilterModel.getEmailSelector(),
                    value: null,
                    placeholder: 'Email',
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 5
        }, {
            name: IndividualFilterModel.getCountryIdSelector(),
            placeholder: 'Country',
            controls: [
                new AutocompleteControl({
                    name: IndividualFilterModel.getCountryIdSelector(),
                    value: null,
                    placeholder: 'Country',
                    validators: [],
                    componentType: ComponentTypesEnum.Autocomplete,
                    options: []
                }),
            ],
            sortIndex: 6
        },
        {
            name: IndividualFilterModel.getEnrollPortalIdsSelector(),
            placeholder: 'Portal',
            controls: [
                new SelectControl({
                    name: IndividualFilterModel.getEnrollPortalIdsSelector(),
                    value: UnspecifiedKeysEnum.UnspecifiedPortalIdKey,
                    placeholder: 'Portal',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: 'All',
                            value: UnspecifiedKeysEnum.UnspecifiedPortalIdKey
                        }
                    ]
                })
            ],
            sortIndex: 7
        }
    ];
};

export const PanelVerificationDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: IndividualReportModel.getEnrollDateSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<number>({
            colId: IndividualReportModel.getStatusNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getEnrollTypeSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getEmailSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getCountryNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getEnrollPortalNameSelector(),
            value: null,
            hidden: false
        }),
    ];
};

export const PanelVerificationsDataTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Enroll Date',
                selector: IndividualReportModel.getEnrollDateSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Status',
                selector: IndividualReportModel.getStatusNameSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Client Type',
                selector: IndividualReportModel.getEnrollTypeSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Name',
                selector: IndividualReportModel.getNameSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Email',
                selector: IndividualReportModel.getEmailSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Country',
                selector: IndividualReportModel.getCountryNameSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Portal',
                selector: IndividualReportModel.getEnrollPortalNameSelector(),
            })
        ],
        hiddenColumnIds: [],
        actionMenu: false
    };
};
